import axios from '../../../axiosConfig';
import { createUserInContext } from '../../users/userCreationApi';

const withTsParam = (params = {}) => ({
  ...params,
  ts: Date.now(),
});

const parseCollection = (payload, keys = []) => {
  if (Array.isArray(payload)) return payload;
  for (const key of keys) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  return [];
};

const uniqueById = (items) =>
  items.filter((value, index, array) => {
    if (!value) return false;
    const key = value?.id != null ? `id:${value.id}` : `idx:${index}:${JSON.stringify(value)}`;
    return array.findIndex((item, itemIndex) => {
      if (!item) return false;
      const itemKey = item?.id != null ? `id:${item.id}` : `idx:${itemIndex}:${JSON.stringify(item)}`;
      return itemKey === key;
    }) === index;
  });

export const getAdminNetworks = async () => {
  const response = await axios.get('/networks', { params: withTsParam() });
  return parseCollection(response?.data, ['networks']);
};

export const createAdminNetwork = async (payload) => {
  const response = await axios.post('/networks', payload);
  return response?.data;
};

export const updateAdminNetwork = async (id, payload) => {
  const response = await axios.patch(`/networks/${id}`, payload);
  return response?.data;
};

export const deleteAdminNetwork = async (id) => {
  return axios.delete(`/networks/${id}`);
};

export const getAdminNetwork = async (id) => {
  const response = await axios.get(`/networks/${id}`, { params: withTsParam() });
  const payload = response?.data || {};
  const network = payload?.network || payload;

  return {
    network,
    organizations: uniqueById(parseCollection(payload, ['organizations', 'network_organizations'])),
    users: uniqueById(parseCollection(payload, ['users', 'network_users'])),
  };
};

export const getAdminOrganizations = async () => {
  const response = await axios.get('/organizations', { params: withTsParam() });
  return parseCollection(response?.data, ['organizations']);
};

export const getAdminConsultants = async () => {
  const response = await axios.get('/consultants', { params: withTsParam() });
  return parseCollection(response?.data, ['consultants']);
};

export const attachOrganizationToAdminNetwork = async (networkId, organizationId) => {
  return axios.post(`/networks/${networkId}/organizations`, { organization_id: organizationId });
};

export const detachOrganizationFromAdminNetwork = async (networkId, organizationId) => {
  return axios.delete(`/networks/${networkId}/organizations/${organizationId}`);
};

export const createAdminNetworkUser = async (networkId, payload) => {
  return createUserInContext({ type: 'network', id: networkId }, payload);
};

export const removeAdminNetworkUser = async (networkId, userId) => {
  return axios.delete(`/networks/${networkId}/users/${userId}`);
};
